import React from 'react';
import { FiUserCheck, FiUserPlus } from 'react-icons/fi';
import ReusableButton from '../../../../../layout/ReusableComponent/Buttons/outline-buttons';

/**
 * Compact Follow control for author/status posts — mirrors Join button styling.
 * Club topics use Join/Joined instead; this control is not shown there.
 */
export function AuthorFollowFeedButton({
  followState,
  loading = false,
  onFollow,
  onUnfollow,
  onCancelRequest,
  className = '',
}) {
  if (!followState || followState.status === 'self') return null;

  if (followState.status === 'active') {
    return (
      <button
        type="button"
        className={`support-open-disc-topic-modern-joined-pill support-open-disc-topic-following-pill support-open-disc-topic-author-follow-btn ${className}`.trim()}
        disabled={loading}
        aria-label="You follow this user"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onUnfollow?.();
        }}
      >
        <FiUserCheck className="support-open-disc-topic-membership-status-icon" aria-hidden />
        <span className="support-open-disc-topic-following-pill__label support-open-disc-topic-following-pill__label--default" aria-hidden="true">
          {loading ? 'Updating…' : 'Following'}
        </span>
        <span className="support-open-disc-topic-following-pill__label support-open-disc-topic-following-pill__label--hover" aria-hidden="true">
          {loading ? 'Updating…' : 'Unfollow'}
        </span>
      </button>
    );
  }

  if (followState.status === 'pending') {
    return (
      <ReusableButton
        type="button"
        variant="outline"
        size="sm"
        color="brand"
        className={`support-open-disc-topic-modern-join-btn support-open-disc-topic-author-follow-btn ${className}`.trim()}
        iconStart={
          <FiUserPlus className="support-open-disc-topic-membership-status-icon" aria-hidden />
        }
        disabled={loading}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onCancelRequest?.();
        }}
      >
        {loading ? 'Updating…' : 'Requested'}
      </ReusableButton>
    );
  }

  return (
    <ReusableButton
      type="button"
      variant="outline"
      size="sm"
      color="brand"
      className={`support-open-disc-topic-modern-join-btn support-open-disc-topic-author-follow-btn ${className}`.trim()}
      iconStart={
        <FiUserPlus className="support-open-disc-topic-membership-status-icon" aria-hidden />
      }
      disabled={loading}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onFollow?.();
      }}
    >
      {loading ? 'Updating…' : 'Follow'}
    </ReusableButton>
  );
}
